import React, { useState } from "react";
import { Box } from "@material-ui/core";
import styled from "styled-components";
import Editor from "./components/Editor";
import PersonalInfoForm from "./components/PersonalInfoForm";
import UploadImage from "./components/UploadImage";
import StyledButton from "../../../../../UIcomponent/Button";
import ProfileReq from "../../../../../Utility/Requester/ProfileReq";
import { Notify } from "../../../../../UIcomponent/NotificationManager";

import "draft-js/dist/Draft.css";
import Axios from "axios";

const Container = styled.div`
  .save-button {
    background-color: blue;
    border-radius: 100%;
  }
`;

const PersonalInfo = (props) => {
  const { data, info } = props;
  const [personalInfo, setPersonalInfo] = useState({
    firstName: info.firstName,
    lastName: info.lastName,
  });
  const [aboutMe, setAboutMe] = useState(data.aboutMe);
  const [isFetching, setIsFetching] = useState(false);

  const savePersonalInfo = () => {
    const data = {
      FirstName: personalInfo.firstName,
      LastName: personalInfo.lastName,
      TimeZone: info.timeZone,
      BirthDate: null,
    };
    console.log(data);
    return ProfileReq.UpdateUser(data);
  };

  const saveAboutMe = () => {
    const data = { AboutMe: aboutMe };
    return ProfileReq.UpdateTeacher(data);
  };

  const onSave = () => {
    setIsFetching(true);

    Axios.all([savePersonalInfo(), saveAboutMe()])
      .then((value) => {
        setIsFetching(false);
        Notify("success", "اطلاعات با موفقیت ذخیره شد.", 3000);
      })
      .catch((e) => {
        setIsFetching(false);
        Notify("error", "خطا در ذخیره سازی اطلاعات، دوباره تلاش کنید.", 3000);
      });
  };

  return (
    <Box p={info.role === "Teacher" ? 0 : 2}>
      <div className="title-bar">
        <h3>اطلاعات فردی</h3>
      </div>
      {console.log(data)}
      <div>
        <UploadImage defaultImage={data?.UserAvatar || data?.avatar} />
        <br />
        <Container>
          <PersonalInfoForm getData={setPersonalInfo} info={info} />
          {info.role === "Teacher" && (
            <Editor getData={setAboutMe} defaultValue={data.AboutMe} />
          )}
          <br />
          <StyledButton loading={isFetching} onClick={() => onSave()} primary>
            ذخیره
          </StyledButton>
        </Container>
      </div>
    </Box>
  );
};

export default PersonalInfo;
